<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card [advanceButton]="true"
                [advancedButtons]="specialButton"
                [dropdownButton]="dropdownButton"
                (outputButtonAdvance)="calFunction($event)"
                (outputDropdownButton)="exportOrders($event)"
                [title]="'global.overview'|translate">
        <app-grid #gridComponent [grid]="grid" (sendParameters)="setParams($event)"
                  (bulkActionResponse)="checkOrderConfirm($event)"
                  (generateInvoiceAction)="selectInvoiceLayout($event)"></app-grid>
      </app-card>
    </div>
  </div>
</div>
<a #downloadLink href="" download style="display: none"></a>
<app-modal-basic #uploadModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{'admin.order.import_delivery_weeks' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="cancelUpload()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'admin.order.import.message_body' | translate}}</p>
    <div class="form-group row">
      <div class="form-group col-md-12">
        <label>{{ 'global.import_file' | translate}} *</label>
        <label class="custom-file">
          <input type="file" ng2FileSelect [uploader]="uploader" class="custom-file-input"
                 (change)="onFileSelected()"
                 #uploadEl id="uploaderFile" accept=".xlsx, .xls, .csv">
          <span class="custom-file-control-upload"
                *ngIf="uploader.queue.length==0">{{"global.choose_file"|translate}}</span>
          <span class="custom-file-control-upload"
                *ngIf="uploader.queue.length>0">{{"global.change_file"|translate}}</span>
          <span
            class="custom-file-control">{{(uploader.queue.length > 0) ? uploader.queue[uploader.queue.length - 1].file.name : ''}}</span>
        </label>
      </div>
    </div>
    <div class="row">
      <!-- Loading Style -->
      <div class="preloader3 loader-block mx-auto" *ngIf="isUploading">
        <div class="circ1 loader-success"></div>
        <div class="circ2 loader-success"></div>
        <div class="circ3 loader-success"></div>
      </div>
    </div>

  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="cancelUpload()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="uploadFile()" [disabled]="isUploading">{{'global.import'|translate}}</button>
  </div>
</app-modal-basic>
<app-modal-basic #confirmActionModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{'global.warning' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="confirmActionModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'doctrine.order.dealer_payment_warning' | translate}}</p>
    <ng-container>
      <ul *ngIf="selectedDealers" style="list-style-type: disc;" class="ps-3">
        <strong>
          <li *ngFor="let dealer of selectedDealers"> {{dealer.companyName}}</li>

        </strong>
      </ul>
    </ng-container>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="confirmActionModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="confirm()">{{'global.continue'|translate}}</button>
  </div>
</app-modal-basic>
<app-modal-basic #exportEmailsModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{'global.export_contact_emails' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="exportEmailsModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <div class="form-row row">
      <div class="form-group col-md-6">
        <label for="contact-function">{{"doctrine.user.category" | translate}}<span class="star">*</span></label>
        <ng-select required name="contactFunction" id="contact-function" [items]="contactFunctionItems"
                   [(ngModel)]="selectedContactFunction" [clearable]="false"></ng-select>
      </div>
      <div class="form-group col-md-6">
        <label for="dealer-profile">{{"doctrine.invoice_dealer.profile" | translate}}<span class="star">*</span></label>
        <ng-select required name="contactFunction" id="dealer-profile" [items]="dealerProfileItems"
                   [(ngModel)]="selectedDealerProfile" [clearable]="false"></ng-select>
      </div>
    </div>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="exportEmailsModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light" [disabled]="!(selectedContactFunction && selectedDealerProfile)"
            (click)="exportIt()">{{'global.confirm'|translate}}</button>
  </div>
</app-modal-basic>
<app-modal-basic #importResultModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{'admin.order.import_delivery_weeks_result' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="importResultModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <ul style="list-style-type: disc" class="ps-3">
      <li *ngFor="let message of messages" [ngClass]="{'text-danger': message.includes('*')}">
      {{message}}
      </li>
    </ul>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-primary ripple light"
            (click)="importResultModal.hide()">{{'global.ok'|translate}}</button>
  </div>
</app-modal-basic>
<ng-template #priceTemp let-row="row" let-value="value" let-column="column">
  {{row?.totalCost?.totalDealerCost| BackofficeCurrency}}
</ng-template>
<ng-template #expectedDeliveryWeekTemp let-row="row" let-value="value" let-column="column">
  <ng-container *ngIf="row.status !== OrderObj.FREE_DELIVERY_AMOUNT_NOT_REACHED.key">
    {{row?.expectedDeliveryWeek ? (row?.expectedDeliveryWeek|WeekDateFormat) : ''}}
  </ng-container>
  <ng-container *ngIf="row.status === OrderObj.FREE_DELIVERY_AMOUNT_NOT_REACHED.key">
    {{ 'doctrine.order.statuses.' + OrderObj.FREE_DELIVERY_AMOUNT_NOT_REACHED['key'] | translate }}
  </ng-container>
</ng-template>

<ng-template #collectionsTemp let-row="row" let-value="value" let-column="column">
  <span class="badge badge-secondary" [title]="getCollectionBadge(row?.orderItemCollections, true)">
    {{getCollectionBadge(row?.orderItemCollections)}}
  </span>
</ng-template>

<ng-template #productionFormsTemp let-row="row" let-value="value" let-column="column">
  <i *ngIf="row?.productionFormsStatus === true" class="check" aria-hidden="true"></i>
  <i *ngIf="row?.productionFormsStatus === null" class="times" aria-hidden="true" ></i>
  <i *ngIf="row?.productionFormsStatus === false" class="check disabled" aria-hidden="true"></i>
</ng-template>
<ng-template #packingListTemp let-row="row" let-value="value" let-column="column">
  <i *ngIf="row?.hasPackagingLabel" class="check" aria-hidden="true"></i>
  <i *ngIf="!row?.hasPackagingLabel" class="times" aria-hidden="true" ></i>
</ng-template>
<ng-template #isInvoicedTemp let-row="row" let-value="value" let-column="column">
  <i *ngIf="row?.isInvoiced" class="check" aria-hidden="true"></i>
  <i *ngIf="!row?.isInvoiced" class="times" aria-hidden="true" ></i>
</ng-template>
<ng-template #statusTmp let-row="row" let-value="value" let-column="column">
  <span [ngSwitch]="row?.status">
    <li *ngSwitchCase="OrderObj.NEW.key" class="status-new">{{'doctrine.order.statuses.new' | translate}}</li>
    <li *ngSwitchCase="OrderObj.IN_PROCESS.key">{{'doctrine.order.statuses.in_process' | translate}}</li>
    <li *ngSwitchCase="OrderObj.DELIVERY.key">{{'doctrine.order.statuses.delivery' | translate}}</li>
    <li *ngSwitchCase="OrderObj.COMPLETED.key">{{'doctrine.order.statuses.completed' | translate}}</li>
    <li *ngSwitchCase="OrderObj.ON_HOLD.key">{{'doctrine.order.statuses.on_hold' | translate}}</li>
    <li *ngSwitchCase="OrderObj.CANCELLED.key">{{'doctrine.order.statuses.cancelled' | translate}}</li>
    <li *ngSwitchCase="OrderObj.CHANGED.key">{{'doctrine.order.statuses.changed' | translate}}</li>
    <li *ngSwitchCase="OrderObj.FREE_DELIVERY_AMOUNT_NOT_REACHED.key">{{'doctrine.order.statuses.in_process' | translate}}</li>
  </span>
</ng-template>


<app-modal-basic #notifyModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{'global.warning' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="hideNotifyModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p class="mb-0">{{ 'doctrine.order.change_status_notify' | translate}}</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="hideNotifyModal()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="confirmChange()">{{'global.continue'|translate}}</button>
  </div>
</app-modal-basic>

<app-modal-basic #generateInvoiceModal>
    <div class="app-modal-header">
      <h4 class="modal-title">{{ 'doctrine.invoice_layout.overview' | translate }}</h4>
      <button type="button" class="close basic-close" (click)="generateInvoiceModal.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="app-modal-body">
      <p>{{ 'admin.invoice_layout.modal.description' | translate}}:</p>
        <form novalidate #generateInvoiceForm="ngForm">
          <div class="form-row row">
            <div class="form-group col-md-12">
              <ng-select [items]="templates"
                         bindLabel="label"
                         bindValue="value"
                         [addTag]="false"
                         [hideSelected]="true"
                         [(ngModel)]="selectedTemplate"
                         name="selectedTemplate">
              </ng-select></div>
          </div>
        </form>
    </div>
    <div class="app-modal-footer">
      <button type="button" class="btn btn-simple ripple me-4"
              (click)="generateInvoiceModal.hide()">{{'global.cancel'|translate}}</button>
      <button type="button" class="btn btn-primary ripple light" [disabled]="!selectedTemplate || isGeneratingInvoice"
              (click)="generateInvoice()">{{'doctrine.order.generate_invoice'|translate}}</button>
    </div>
</app-modal-basic>

<ng-template #rowDetail let-row="row" let-value="value" let-column="column">
  <table class="table ignore-margin-bottom">
    <thead>
    <tr class="header-row-inner-table">
      <td>{{'doctrine.order.exact_no' | translate}}</td>
      <td>{{'doctrine.order.partial_order' | translate}}</td>
      <td>{{'doctrine.order.requested_delivery_week' | translate}}</td>
      <td>{{'doctrine.backoffice.order.delivery_week' | translate}}</td>
      <td>{{'doctrine.collection.collections' | translate}}</td>
      <td>{{'doctrine.order.invoice_no' | translate}}</td>
      <td>{{'doctrine.order.packing_list_no' | translate}}</td>
      <td *ngIf="row?.workForm">{{'doctrine.order.workform_no' | translate}}</td>
      <td *ngIf="row?.sticker">{{'doctrine.order.sticker_no' | translate}}</td>
      <td *ngIf="row?.internalPackagingLabel">{{'doctrine.order.internal_packaging_label_no' | translate}}</td>
      <td>{{'doctrine.order.total' | translate}}
      <small class="text-muted">({{'doctrine.order.total_incl_vat' | translate}})</small>
      </td>
      <td>{{'doctrine.order.total' | translate}}
        <small class="text-muted">({{'doctrine.order.total_ex_vat' | translate}})</small>
      </td>
    </tr>
    </thead>
    <tbody>
    <tr class="data-row-inner-table">
      <td>{{row?.exactOrderNumber}}</td>
      <td>
        <i *ngIf="row?.allowPartial" class="check" aria-hidden="true"></i>
        <i *ngIf="!row?.allowPartial" class="times" aria-hidden="true" ></i>
      </td>
      <td *ngIf="!row?.hasSeparateDeliveryWeek">
        {{row?.deliveryWeek ? (row?.deliveryWeek|WeekDateFormat) : ''}}
      </td>
      <td *ngIf="row?.hasSeparateDeliveryWeek">
        {{row?.secondaryDeliveryWeek ? (row?.secondaryDeliveryWeek|WeekDateFormat) : ''}}
      </td>
      <td>
        {{row?.expectedDeliveryWeek ? (row?.expectedDeliveryWeek|WeekDateFormat) : ''}}
      </td>
      <td>
        <span class="badge badge-secondary"
              *ngFor="let orderItemCollection of row?.orderItemCollections?.split(',')">
          {{orderItemCollection}}
        </span>
      </td>
      <td>
        <a (click)="getInvoicePdf(row)">
          <u>{{row?.invoices?.[0]?.invoiceNo || ''}}</u>
        </a>
      </td>
      <td>
      <a (click)="getPdf(row?.packagingLabels?.[0])">
        <u>{{row?.packagingLabels?.length > 0 ? (row?.packagingLabels?.[0]?.packingListNumber || row?.packagingLabels?.[0]?.id) : ''}}</u>
      </a>
      </td>
      <td *ngIf="row?.workForm">
        <a (click)="getPdf(row?.workForm)">
          <u>{{row?.workForm?.code || ''}}</u>
        </a>
      </td>
      <td *ngIf="row?.sticker">
        <a (click)="getPdf(row?.sticker)">
          <u>{{row?.sticker?.code || ''}}</u>
        </a>
      </td>
      <td *ngIf="row?.internalPackagingLabel">
        <a (click)="getPdf(row?.internalPackagingLabel)">
          <u>{{row?.internalPackagingLabel?.code || ''}}</u>
        </a>
      </td>
      <td>{{(row?.user.isCustomerAccount ? row?.totalCost?.totalCustomerCost : row?.totalCost?.totalDealerCost) |BackofficeCurrency}}</td>
      <td>{{(row?.user.isCustomerAccount ? row?.totalCost?.totalCustomerPrice : row?.totalCost?.totalDealerPrice) |BackofficeCurrency}}</td>
    </tbody>
  </table>

</ng-template>
